<template>
  <b-modal
    v-model="showModal"
    title="Chi tiết IMEI đã chọn"
    size="xl"
    hide-footer
    scrollable
    @hidden="onHidden"
  >
    <b-overlay :show="isLoading" rounded="sm">
      <div v-if="imeiData.length" class="imei-detail-modal">
        <p class="mb-3 text-dark" style="font-weight: 500">
          Tổng: {{ imeiData.length }} IMEI
        </p>
        <b-table
          :items="imeiData"
          :fields="fields"
          bordered
          hover
          responsive
          small
          head-variant="light"
        >
          <template v-slot:cell(sellingPrice)="row">
            <span v-text="convertPrice(row.item.sellingPrice)"></span>
          </template>
          <template v-slot:cell(subProviderName)="row">
            <span v-text="row.item.subProviderName"></span><br/>
            <small v-if="row.item.subProviderCode">Mã: <span class="text-warning" v-text="row.item.subProviderCode"></span></small>
          </template>
          <template v-slot:cell(originalPrice)="row">
            <span v-if="checkPermission('PRODUCT_ORIGINAL_PRICE_VIEW')" v-text="convertPrice(row.item.originalPrice)"></span>
            <i
              v-else
              class="fas fa-lock text-muted"
              v-b-tooltip.hover
              title="Bạn không có quyền xem giá nhập"
            ></i>
          </template>
        </b-table>
      </div>
      <div v-else-if="!isLoading" class="text-center py-4 text-muted">
        Không có dữ liệu
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service'
import { convertPrice, makeToastFaile } from '@/utils/common';
import permissionMixin from '@/view/mixins/permission.mixin';

export default {
  mixins: [permissionMixin],
  name: 'ImeiDetailModal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    imeiIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      imeiData: [],
      fields: [
        { key: 'barCode', label: 'Mã vạch', thStyle: { minWidth: '120px' } },
        { key: 'productCode', label: 'Mã sản phẩm', thStyle: { minWidth: '130px' } },
        { key: 'productName', label: 'Tên sản phẩm', thStyle: { minWidth: '200px' } },
        { key: 'imeiNo', label: 'IMEI', thStyle: { minWidth: '150px' } },
        { key: 'providerName', label: 'Nhà cung cấp', thStyle: { minWidth: '150px' } },
        { key: 'subProviderName', label: 'Nhà cung cấp phụ', thStyle: { minWidth: '150px' } },
        { key: 'storeName', label: 'Cửa hàng', thStyle: { minWidth: '120px' } },
        {
          key: 'originalPrice',
          label: 'Giá nhập',
          thStyle: { minWidth: '100px', textAlign: 'right' },
          tdClass: 'text-right',
        },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          thStyle: { minWidth: '100px', textAlign: 'right' },
          tdClass: 'text-right',
        },
        { key: 'saleDate', label: 'Ngày bán', thStyle: { minWidth: '100px' } },
        { key: 'status', label: 'Trạng thái', thStyle: { minWidth: '120px' } },
        { key: 'importDate', label: 'Ngày nhập', thStyle: { minWidth: '100px' } },
        { key: 'description', label: 'Ghi chú', thStyle: { minWidth: '150px' } },
      ],
    }
  },
  watch: {
    show(val) {
      this.showModal = val
      if (val && this.imeiIds.length > 0) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    convertPrice,
    async fetchDetail() {
      this.isLoading = true
      this.imeiData = []
      try {
        const { data } = await ApiService.post('v1/product-imei-stocks/detail-by-ids', {
          ids: this.imeiIds,
        })
        if (data.status === 1 || data.status === 200) {
          this.imeiData = data.data || []
        } else {
          makeToastFaile(data.message || 'Lỗi khi lấy chi tiết IMEI')
        }
      } catch (error) {
        const message = error?.response?.data?.message || error.message || 'Lỗi'
        makeToastFaile(message)
      } finally {
        this.isLoading = false
      }
    },
    onHidden() {
      this.imeiData = []
      this.$emit('hide')
    },
  },
}
</script>

<style scoped>
.imei-detail-modal {
  min-height: 200px;
}
</style>
